import { Module } from 'vuex'
import { getters } from '@/store/modules/facturaE/facturaEGetters'
import { actions } from '@/store/modules/facturaE/facturaEActions'
import { mutations } from '@/store/modules/facturaE/facturaEMutations'
import { RootState } from '@/store/types/storeGlobalTypes'
import { amendReason, amendCodeTax, IFacturaEState } from '@/store/modules/facturaE/facturaETypes'

export const state: IFacturaEState = {
  invoiceId: null,
  paymentType: undefined,
  bankdata: [],
  professionalList: [],
  selectedProfessional: null,
  amendReason,
  amendCodeTax
}

const namespaced: boolean = true

export const facturaEModule: Module<IFacturaEState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
}
